// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  campId: __t.string().primaryKey().name("camp_id"),
  matchId: __t.string().name("match_id"),
  armyIndex: __t.u32().name("army_index"),
  generalUnitId: __t.string().name("general_unit_id"),
  x: __t.f64(),
  y: __t.f64(),
  radius: __t.f64(),
  hp: __t.f64(),
  maxHp: __t.f64().name("max_hp"),
  tentCount: __t.u32().name("tent_count"),
  maxTents: __t.u32().name("max_tents"),
  tentsJson: __t.string().name("tents_json"),
  placedTick: __t.u32().name("placed_tick"),
  completed: __t.bool(),
  constructionProgress: __t.f64().name("construction_progress"),
  constructionRequired: __t.f64().name("construction_required"),
});
